import { ANALYTICS_MENU } from './analytics';
import { APARTMENT_LIST_MENU } from './apartmentList';
import { APARTMENT_STATUS_MENU } from './apartmentStatus';
import { CALLS_MENU } from './calls';
import { DEFECTS_MENU } from './defects';
import { DOCUMENTS_MENU } from './documents';
import { ENGINEERING_MENU } from './engineering';
import { PLACEMENTS_STATUS_MENU } from './placementsStatus';
/* import { PLAN_ENG_NET_COMMISING_MENU } from './planEngNetCommissioning'; */
import { PLAN_MENU } from './plan';
import { SETTING_MENU } from './setting';
import { START_SETTLEMENT_MENU } from './startSettlement';
import { DELIVERY_SCHEDULE_MENU } from './deliverySchedule';
import { TIMESHEET_MENU } from './timesheet';
import { TIMETABLE } from './timetable';
import { UPDATES_MENU } from './updates';
import { UPLOADING_PLAN_MENU } from './uploadingPlan';

// В будущем просто будем использовать для этого ФП apartmentStatus.tsx
import { APARTMENT_STATUS_FP_MENU } from './apartmentStatus_FP';

export const MENU_ITEMS = [
  ANALYTICS_MENU,
  APARTMENT_LIST_MENU,
  APARTMENT_STATUS_MENU,
  CALLS_MENU,
  DEFECTS_MENU,
  DOCUMENTS_MENU,
  ENGINEERING_MENU,
  PLACEMENTS_STATUS_MENU,
  /* PLAN_ENG_NET_COMMISING_MENU, */
  PLAN_MENU,
  DELIVERY_SCHEDULE_MENU,
  SETTING_MENU,
  START_SETTLEMENT_MENU,
  TIMESHEET_MENU,
  TIMETABLE,
  UPDATES_MENU,
  UPLOADING_PLAN_MENU,

  // В будущем просто будем использовать для этого ФП apartmentStatus.tsx
  APARTMENT_STATUS_FP_MENU,
];
